<template>
    <div class="create_page">
        <div style="margin-bottom: 10px;">
            <span style="font-size: 14px;font-weight: 600;padding-right: 20px;cursor: pointer;" @click="handleBack">
                <i class="el-icon-back"></i>Return</span>|
            <span style="font-size: 14px;font-weight: 600;padding-right: 20px;padding-left: 20px;">
                {{
                    type == 'create' ? 'Create Template' : pull['template_name']
                }}
            </span>
            <el-button type="primary" size="mini" :disabled="type == 'info' ? true : false" :loading="submitloading"
                @click="handleSubmit">Save</el-button>
        </div>
        <el-form :disabled="type == 'info' ? true : false" :inline="true" :model="formInline" :rules="rules"
            ref="formInline" class="demo-form-inline" size="mini">
            <el-form-item label="Template Name" prop="template_name">
                <el-input v-model.trim="formInline.template_name" maxlength="20" show-word-limit placeholder="Please enter the template name"
                    style="width:230px;" clearable />
            </el-form-item>
            <el-form-item label="Media" prop="plat_id">
                <el-select v-model="formInline.plat_id" placeholder="Please select a media" style="width:120px;" clearable
                    @visible-change="handleMediaFocus" @change="handleMediaChange" :disabled="this.pull? (this.pull['use_num'] && this.pull.use_num > 0) : false">
                    <el-option :label="item['name']" :value="item['id']" v-for="item in platList" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Template description" prop="desc">
                <el-input v-model.trim="formInline.desc" maxlength="30" show-word-limit placeholder="Please enter template description"
                    style="width:300px;" clearable />
            </el-form-item>

            <!-- <el-form-item>
                <el-button type="primary" @click="onSubmit">筛选</el-button>
                <el-button @click="resetForm('formInline')">Reset Filters</el-button>
            </el-form-item> -->
        </el-form>

        <div class="temp_create">
            <div class="sheet">
                <div class="title">
                    <h5>sheet</h5>
                    <el-button type="primary" plain icon="el-icon-plus" size="mini" :loading="addloading"
                        :disabled="type == 'info' ? true : false" @click="handleDialog('add')">Add</el-button>
                </div>
                <div class="create_body" v-loading='loading'>
                    <div class="create_list" v-if="type != 'info'">
                        <Draggable :list="list" ghost-class="drag-ghost" group="field_sheet">
                            <div class="list_item" :class="item.sheet_id == sheetActive ? 'active' : ''"
                                v-for="(item, index) in list" :key="index">
                                <div v-show="item.checked == 1" class="list_item_checked">
                                    <div class="list_item_title"
                                        @click.stop.prevent="handleSheetActive(item.sheet_id, item.template_name, index)">
                                        <i class="el-icon-rank" style="margin-right: 4px;"></i>
                                        <span class="list_item_title_text">
                                            {{ item.template_name }}
                                        </span>
                                    </div>

                                    <div class="action">
                                        <i class="el-icon-edit-outline" @click="handleEditPop(item.sheet_id)"></i>
                                        <el-popconfirm confirm-button-text='Confirm' cancel-button-text='Cancel' icon="el-icon-info"
                                            icon-color="red" @confirm="handleSheetDel(item.sheet_id)"
                                            title="Deleting the sheet will clear the selected fields, confirm to delete?">
                                            <i class="el-icon-delete" slot="reference"></i>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                    <div class="create_list_nodrag" v-else>
                        <div class="list_item" :class="item.sheet_id == sheetActive ? 'active' : ''"
                            v-for="(item, index) in list" :key="index">
                            <div class="list_item_title" v-show="item.checked == 1"
                                @click.stop.prevent="handleSheetActive(item.sheet_id, item.template_name, index)">
                                <span class="list_item_title_text">
                                    {{ item.template_name }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="checkList">
                <div class="title">
                    <h5>Col</h5>
                    <el-button v-if="sheetActive != 1" type="primary" :disabled="type == 'info' ? true : false" plain
                        icon="el-icon-plus" size="mini" style="margin: 0 20px;"
                        @click="handleDialog('pull')">Sync to other sheets</el-button>
                    <el-button v-else type="primary" :disabled="true" plain icon="el-icon-plus" size="mini"
                        style="margin: 0 20px;">Sync to other sheets</el-button>
                    <p style="color: #656565;">Sync the set metrics, names, and order to other sheets</p>
                </div>

                <div class="check_con" v-loading='loading'>
                    <div class="check_header">
                        <div v-for="(item, index) in list" :key="index">
                            <h5 v-show="item.checked == 1 && item.sheet_id == sheetActive">
                                <el-checkbox style="margin-right: 6px;" v-model="item['checkSheet']"
                                    :disabled="item['disabled'] == 0 ? true : false"
                                    @change="(val) => handleSheetAll(val, index)">
                                        {{ getTemname() }}
                                </el-checkbox>
                            </h5>
                        </div>

                    </div>
                    <div class="check_body">
                        <div class="left">
                            <div v-for="(item, index) in list" :key="index">
                                <div class="check_left_list" v-show="item.checked == 1 && item.sheet_id == sheetActive">
                                    <div class="check_left_list_item" v-for="item_header in item['field']"
                                        :key="item_header['id']">
                                        <div class="check_header">
                                            <el-checkbox v-model="item_header['checkAll']"
                                                :indeterminate="item_header['isIndeterminate']"
                                                :disabled="item_header['disabled'] == 0 ? true : false"
                                                @change="(val) => handleCheckAllChange(val, item_header['id'])">
                                                {{ item_header.display_name }}</el-checkbox>
                                        </div>

                                        <div style="padding: 0 8px;margin-bottom: 10px;">
                                            <el-checkbox-group v-model="item_header['list']" class="wk-el-checkbox-group"
                                                @change="(value) => handleGroupCheckedChange(value, item_header['id'])">
                                                <div class="wk-el-checkbox mb8"
                                                    v-for="item_children in item_header['children']">
                                                    <el-checkbox :label="item_children['id']" :key="item_children['id']"
                                                        :disabled="item_children['disabled'] == 0 ? true : false"
                                                        v-model="item_children['checked']"
                                                        @change="(value) => handleCheckedChange(value, item_children, item_header['id'])">
                                                        <!-- {{ item_children['display_name'].length < 12 ? item_children['display_name'] : `${item_children['display_name'].substring(0 , 9)}...` }} -->
                                                        <span v-if="item_children['display_name'] && item_children['display_name'].length < 12">{{ item_children['display_name'] }}</span>
                                                        <el-tooltip
                                                            v-else
                                                            effect="dark" :content="item_children['display_name']"
                                                            placement="top">
                                                            <span>{{ item_children['display_name'].substring(0 , 9) }}...</span>
                                                        </el-tooltip>
                                                    </el-checkbox>
                                                    <el-tooltip
                                                        v-if="item_children['config'] && item_children['config']['title']"
                                                        effect="dark" :content="item_children['config']['title']"
                                                        placement="top">
                                                        <span class="questions">?</span>
                                                    </el-tooltip>

                                                </div>
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div v-for="(item, index) in list" :key="index">
                                <div v-show="item.checked == 1 && item.sheet_id == sheetActive">
                                    <div class="button-group">
                                        <div class="button-group-item" :class="item['tagActive'] == 1 ? 'active' : ''"
                                            @click="handleTag(1)">Metrics</div>
                                        <div class="button-group-item" :class="item['tagActive'] == 2 ? 'active' : ''"
                                            @click="handleTag(2)">Dimensions </div>
                                    </div>
                                    <div class="right-body" v-if="type != 'info'">
                                        <div class="check_right_list" v-show="item['tagActive'] == 1">
                                            <Draggable :list="item['target']" ghost-class="drag-ghost" group="field_target">
                                                <div class="check_right_list_item" v-for="(item_t, index) in item['target']"
                                                    :key="index">
                                                    <div class="list_item_title">
                                                        <i class="el-icon-rank" style="margin-right: 4px;"></i>

                                                        <el-tooltip class="item" effect="dark"
                                                            :content="'Original Metric Name:' + item_t.display_name" placement="top"
                                                            v-if="item_t.edit_name != item_t.display_name">
                                                            <span class="list_item_title_text"
                                                                :style="{ color: item_t.edit_name != item_t.display_name ? '#63A103' : '' }">
                                                                {{ item_t.edit_name }}
                                                            </span>
                                                        </el-tooltip>
                                                        <span class="list_item_title_text" v-else>
                                                            {{ item_t.edit_name }}
                                                        </span>
                                                    </div>
                                                    <div class="action">
                                                        <i class="el-icon-edit-outline"
                                                            @click="handleCheckPop(index, 'target')"></i>
                                                        <!-- <el-popconfirm confirm-button-text='确定' cancel-button-text='取消'
                                                            icon="el-icon-info" icon-color="red"
                                                            @confirm="handleCheckDel(index, item_t['id'])" title="确定要删除吗？">
                                                            <i class="el-icon-delete" slot="reference"></i>
                                                        </el-popconfirm> -->
                                                        <i class="el-icon-delete" @click="handleCheckDel(index, item_t['id'])"></i>
                                                    </div>
                                                </div>
                                            </Draggable>
                                        </div>
                                        <div class="check_right_list" v-show="item['tagActive'] == 2">
                                            <div class="check_right_list_item" v-for="(item_d, index) in item['dimension']"
                                                :key="index">
                                                <div class="list_item_title">
                                                    <el-tooltip class="item" effect="dark"
                                                        :content="'Original Dimension Name:' + item_d.display_name" placement="top"
                                                        v-if="item_d.edit_name != item_d.display_name">
                                                        <span class="list_item_title_text"
                                                            :style="{ color: item_d.edit_name != item_d.display_name ? '#63A103' : '' }">
                                                            {{ item_d.edit_name }}
                                                        </span>
                                                    </el-tooltip>
                                                    <span class="list_item_title_text" v-else>
                                                        {{ item_d.edit_name }}
                                                    </span>
                                                </div>
                                                <div class="action">
                                                    <i class="el-icon-edit-outline"
                                                        @click="handleCheckPop(index, 'dimension')"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right-body" v-else>
                                        <div class="check_right_list" v-show="item['tagActive'] == 1">
                                            <div class="check_right_list_item" v-for="(item_t, index) in item['target']"
                                                :key="index">
                                                <div class="list_item_title">
                                                    <i class="el-icon-rank" style="margin-right: 4px;"></i>

                                                    <el-tooltip class="item" effect="dark"
                                                        :content="'Original Metric Name:' + item_t.display_name" placement="top"
                                                        v-if="item_t.edit_name != item_t.display_name">
                                                        <span class="list_item_title_text"
                                                            :style="{ color: item_t.edit_name != item_t.display_name ? '#63A103' : '' }">
                                                            {{ item_t.edit_name }}
                                                        </span>
                                                    </el-tooltip>
                                                    <span class="list_item_title_text" v-else>
                                                        {{ item_t.edit_name }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="check_right_list" v-show="item['tagActive'] == 2">
                                            <div class="check_right_list_item" v-for="(item_d, index) in item['dimension']"
                                                :key="index">
                                                <div class="list_item_title">
                                                    <el-tooltip class="item" effect="dark"
                                                        :content="'Original Dimension Name:' + item_d.display_name" placement="top"
                                                        v-if="item_d.edit_name != item_d.display_name">
                                                        <span class="list_item_title_text"
                                                            :style="{ color: item_d.edit_name != item_d.display_name ? '#63A103' : '' }">
                                                            {{ item_d.edit_name }}
                                                        </span>
                                                    </el-tooltip>
                                                    <span class="list_item_title_text" v-else>
                                                        {{ item_d.edit_name }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 弹框 -->
        <el-dialog :visible.sync="dialogVisible" :title="dialogList[dialogtype]['title']" width="550px" append-to-body
            :before-close="handleClose" destroy-on-close :close-on-click-modal="false">
            <div>

                <p style="color: #000;margin-bottom: 10px;">{{dialogList[dialogtype]['desc']}}</p>
                <el-checkbox :indeterminate="dialogList[dialogtype]['dialogIsIndeterminate']"
                    v-model="dialogList[dialogtype]['dialogCheckAll']"
                    @change="(val) => handleDialogCheckAllChange(val, dialogtype)">Select All</el-checkbox>
                <div style="margin: 0 0 10px 0;"></div>
                <el-checkbox-group v-model="dialogList[dialogtype]['dialogChecked']"
                    @change="(value) => handleCheckedDialogChange(value, dialogtype)">
                    <el-checkbox v-for="item in dialogList[dialogtype]['list']" :label="item['sheet_id']"
                        :key="item['sheet_id']">{{
                            item['template_name'] }}</el-checkbox>
                </el-checkbox-group>

            </div>
            <div slot="footer" class="dialog-footer tac">
                <el-button type="default" @click="handleClose(dialogtype)" class="action-btn mr20">Cancel</el-button>
                <el-button type="primary" @click="handleOk(dialogtype)" class="action-btn ml20">Submit</el-button>
            </div>
        </el-dialog>
        <!-- 修改弹框 -->
        <el-dialog :visible.sync="dialogVisibleEdit" :title="dialogEditList[dialogEdittype]['title']" width="550px"
            append-to-body :before-close="handleEditClose" destroy-on-close :close-on-click-modal="false">
            <div>
                <el-input type="text" placeholder="Please Enter Content" v-model="dialogEditList[dialogEdittype]['text']" maxlength="15"
                    show-word-limit></el-input>
            </div>
            <div slot="footer" class="dialog-footer tac">
                <el-button type="default" @click="handleEditClose(dialogEdittype)" class="action-btn mr20">Cancel</el-button>
                <el-button type="primary" @click="handleEditOk(dialogEdittype)" class="action-btn ml20">Save</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Draggable from 'vuedraggable';
import { cloneDeep, uniqBy, uniq } from 'lodash'
import {
    getTemplateFields,
    postTemplateCreate,
    getTemplateEdit,
    postTemplateUpdate,
} from '@/api/efficiencyToolEn/template.js'

export default {
    name: 'efficiencyTool_temp_create',
    components: {
        Draggable,
    },
    props: ['type', 'pull', 'allowedPlatList'],
    data() {
        const pList = this.allowedPlatList.filter(v=>['爱奇艺'].includes(v.name));
        return {
            platList: pList,
            longText: '这里是一段长长的文本，当文本内容超出容器时，鼠标移入时会滚动起来。',
            loading: false,
            submitloading: false,
            addloading: false,
            prev_plat_id: '',
            formInline: {
                template_name: '',
                plat_id: '',
                desc: ''
            },
            rules: {
                template_name: [
                    { required: true, message: 'Please enter the template name', trigger: 'blur' },
                    { min: 1, max: 20, message: 'Maximum length is 20 characters', trigger: 'blur' }
                ],
                plat_id: [
                    { required: true, message: 'Please select a media', trigger: 'change' }
                ]
            },
            checkSheet: false, //sleet全选
            dialogCheckList: [],
            list: [],  //模板sleet 与 checkBox
            sheetIndex: 0, //sheet 第几个
            sheetActive: '1',   //sheet 点击
            name: 'Account Info',
            addList: [],
            pullList: [],
            tagIndex: 1,     //指标与维度选中  1 2
            // tagLeftList: [],   //指标  2
            // tagRightList: []  //维度  0

            dialogVisible: false,  //弹框 
            dialogtype: 'add',  //add 添加sheet   pull同步至其他sheet
            dialogList: {
                add: {
                    title: 'Add sheet',
                    desc: 'Please check the sheets to be added, multiple selections are allowed',
                    dialogCheckAll: false,
                    dialogChecked: [],
                    dialogIsIndeterminate: false,
                    list: []
                },
                pull: {
                    title: 'Synchronize to other sheets',
                    desc: 'Please select the sheets to synchronize, multiple choices are allowed',
                    dialogCheckAll: false,
                    dialogChecked: [],
                    dialogIsIndeterminate: false,
                    list: []
                }
            },
            dialogVisibleEdit: false,  //修改弹框 
            dialogEdittype: 'sheet',
            dialogEditList: {
                sheet: {
                    title: 'Edit sheet name',
                    text: ''
                },
                target: {
                    title: 'Edit table header',
                    text: ''
                }
            }
        }
    },
    computed:{
    },
    created() {
        if (this.type == 'edit' || this.type == 'info' || this.type == 'copy') {
            this.platList = uniqBy([...this.allowedPlatList, {id: this.pull['plat_id'], name: this.pull['plat_name']}], 'id') 

            this.formInline['template_name'] = this.pull['template_name']
            this.formInline['plat_id'] = this.pull['plat_id']
            this.formInline['desc'] = this.pull['desc']
            this.prev_plat_id = this.pull['plat_id']
            this.loading = true
            getTemplateEdit({ plat_id: this.pull['plat_id'], template_id: this.pull['template_id'] }).then(res => {
                this.initList(res.data.sheet)
            },err => {
                this.$message.error(err.info);
            })
        }else{
            let platId = this.platList.length>0?this.platList[0].id:'';
            let pullPlatId = (this.pull||{}).plat_id||'';
            this.formInline['plat_id'] = pullPlatId||platId;
            this.prev_plat_id = pullPlatId||platId;
            this.loading = true
            getTemplateFields({ plat_id: this.formInline['plat_id'] }).then(res => {
                let result_data = res.data.map(item=>{
                    item['checked'] = 1
                    return item
                })
                this.initList(result_data)
            }, err => {
                this.$message.error(err.info);
            })
        }
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        handleBack() {
            this.$emit('goBack', true)
        },
        getTemname() {
            if(this.list.length != 0) {
                let isblea = this.list.filter(item => item['sheet_id'] == this.sheetActive)
                if(isblea.length == 0) {
                    return ''
                }else{
                    return isblea[0]['template_name']
                }
            }else {
                return ''
            }
        },
        //排序，处理sheet页面添加 保持原有排序不变
        compareNumbers(a, b) {
            return Number(a['sheet_id']) - Number(b['sheet_id']);
        },
        //初始化 处理list 数据
        initList(result) {
            this.dialogCheckList = result && result.map(item => { return { sheet_id: item['sheet_id'], template_name: item['template_name'] } }).sort(this.compareNumbers)
            this.list = result && result.map((item, index) => {
                item['indexs'] = index
                item['tagActive'] = 1
                item['checkSheet'] = false
                item['sleet_length'] = []   //全部checkbox
                let init_target = []
                let init_dimension = []
                if (this.type == 'info') {
                    item['disabled'] = 0
                } else {
                    item['disabled'] = 1
                }
                item['field'].map(item_c => {
                    item_c['checkAll'] = false
                    item_c['isIndeterminate'] = false
                    item_c['list'] = []
                    if (this.type == 'info') {
                        item_c['disabled'] = 0
                    }
                    item_c.children && item_c.children.forEach(element => {
                        item['sleet_length'].push(element.id)
                        if (this.type == 'create') {
                            element['edit_name'] = element['display_name']
                        }
                        if (this.type == 'info') {
                            element['disabled'] = 0
                        }
                        if (element.checked == 1) {
                            item_c['list'].push(element.id)
                        }
                        if (this.type != 'edit' && this.type != 'info') {
                            if (element['field_type'] == 2) {
                                if (element.checked == 1) {
                                    init_target.push(element)
                                }
                            } else if (element['field_type'] == 0) {
                                if (element.checked == 1) {
                                    init_dimension.push(element)
                                }
                            }
                        }
                    })

                    let checkedCount = item_c['list'].length
                    item_c['checkAll'] = checkedCount == item_c.children.length;
                    item_c['isIndeterminate'] = checkedCount > 0 && checkedCount < item_c.children.length;
                    return item_c
                })
                if (this.type != 'edit' && this.type != 'info' && this.type != 'copy') {
                    item['target'] = init_target
                    item['dimension'] = init_dimension
                    item['checkSheet'] = item['sleet_length'].length == (Number(init_target.length) + Number(init_dimension.length))
                } else {
                    item['checkSheet'] = item['sleet_length'].length == (Number(item['target'].length) + Number(item['dimension'].length))
                }

                return item
            })
            if (this.list.length != 0) {
                this.sheetIndex = 0
                this.sheetActive = this.list[0]['sheet_id']
            }
            this.loading = false
        },
        // 缓存上一次媒体选择
        handleMediaFocus(val) {
            // console.log('val', this.pull.use_num)
            // if(this.pull.use_num && this.pull.use_num > 0) {
            //     this.$message({
            //         message: '使用过的模板，不可以切换媒体',
            //         type: 'warning'
            //     });
            //     return
            // }
            if (val) {
                this.prev_plat_id = this.formInline.plat_id
            }

        },
        // 媒体选择
        handleMediaChange(val) {
            this.formInline.plat_id = this.prev_plat_id
            if(!val) {
               
                this.$confirm('Delete media. Selected fields will be cleared. Are you sure you want to delete them', 'Prompt', {
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    // this.type = 'create'
                    this.$emit('changeType', 'create')
                    this.addloading = true
                    getTemplateFields({ plat_id: val }).then(res => {
                        let result_data = res.data.map(item=>{
                            item['checked'] = 1
                            return item
                        })
                        this.loading = true
                        this.initList(result_data)
                        this.addloading = false
                        // this.initList(res.data)
                        this.$message({
                            type: 'success',
                            message: 'Delete successfully'
                        });
                        this.formInline.plat_id = val
                    }, err => {
                        this.addloading = false
                        this.$message.error(err.info);
                    })
                    
                }).catch(() => {
                    this.formInline.plat_id = this.prev_plat_id
                    this.$message({
                        type: 'info',
                        message: 'Cancelled deletion'
                    });
                });
            }else{
                if(this.prev_plat_id) {
                        this.$confirm('After switching media, the selected fields will be cleared. Are you sure you want to switch?', 'Prompt', {
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        // this.type = 'create'
                        this.$emit('changeType', 'create')
                        this.addloading = true
                        getTemplateFields({ plat_id: val }).then(res => {
                            let result_data = res.data.map(item=>{
                                item['checked'] = 1
                                return item
                            })
                            this.loading = true
                            this.initList(result_data)
                            this.addloading = false
                            this.$message({
                                type: 'success',
                                message: 'Success'
                            });
                            this.formInline.plat_id = val
                            this.prev_plat_id = this.formInline.plat_id
                        }, err => {
                            this.addloading = false
                            this.$message.error(err.info);
                        })
                        
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Cancelled deletion'
                        });
                    });
                }else{
                    // this.type = 'create'
                    this.$emit('changeType', 'create')
                    this.addloading = true
                    getTemplateFields({ plat_id: val }).then(res => {
                        let result_data = res.data.map(item=>{
                            item['checked'] = 1
                            return item
                        })
                        this.loading = true
                        this.initList(result_data)
                        this.addloading = false
                        this.$message({
                            type: 'success',
                            message: 'Success!'
                        });
                        this.formInline.plat_id = val
                        this.prev_plat_id = this.formInline.plat_id
                    }, err => {
                        this.addloading = false
                        this.$message.error(err.info);
                    })
                }
                
            }
        },
        // sheet 点击
        handleSheetActive(value, name, index) {
            this.sheetIndex = index
            this.sheetActive = value
            this.name = name
        },
        // 指标 维度 点击
        handleTag(value) {
            this.list.map(item => {
                if (item.sheet_id == this.sheetActive) {
                    item['tagActive'] = value
                }
                return item
            })
        },
        //sheet 全选事件
        handleSheetAll(val, index) {
            let all_target = []
            let all_dimension = []
            this.list.map(item => {
                if (item.sheet_id == this.sheetActive) {
                    item.field.map(item_c => {
                        let rew_list = []
                        item_c.children && item_c.children.forEach(element => {
                            if (val) {
                                // 全部添加
                                rew_list.push(element.id)
                                if (element['field_type'] == 2) {
                                    // item['target'].push(element)
                                    all_target.push(element)

                                } else if (element['field_type'] == 0) {
                                    // item['dimension'].push(element)
                                    all_dimension.push(element)
                                }
                            } else {
                                // 全部移除
                                if (element.disabled == 0) {
                                    rew_list.push(element.id)
                                } else {
                                    if (element['field_type'] == 2) {
                                        item['target'].forEach((itemTarget, index) => {
                                            if (itemTarget['id'] == element['id']) {
                                                item['target'].splice(index, 1)
                                            }
                                        })
                                    } else if (element['field_type'] == 0) {
                                        item['dimension'].forEach((itemTarget, index) => {
                                            if (itemTarget['id'] == element['id']) {
                                                item['dimension'].splice(index, 1)
                                            }
                                        })
                                    }
                                }
                            }

                        })
                        if (val) {
                            item_c['checkAll'] = true
                            item_c['isIndeterminate'] = false
                        } else {
                            item_c['checkAll'] = false
                            item_c['isIndeterminate'] = false
                        }
                        item_c['list'] = rew_list
                        return item_c
                    })
                    if (val) {
                        // 同步指标数据 指标数据需要同步排序
                        let cur_target = []
                        item['target'].forEach(itemt => {
                            all_target.forEach(itemc => {
                                if (itemt['name'] == itemc['name']) {
                                    itemc['edit_name'] = itemt['edit_name']
                                    cur_target.push(itemc)
                                }
                            })
                        })
                        let other_target = uniqBy([...cur_target, ...all_target], 'id')
                        item['target'] = other_target

                        // 同步维度数据 维度数据需要同步排序
                        let cur_dimension = []
                        item['dimension'].forEach(itemt => {
                            all_dimension.forEach(itemc => {
                                if (itemt['name'] == itemc['name']) {
                                    itemc['edit_name'] = itemt['edit_name']
                                    cur_dimension.push(itemc)
                                }
                            })
                        })
                        let other_dimension = uniqBy([...cur_dimension, ...all_dimension], 'id')

                        item['dimension'] = other_dimension
                    }
                    item['checkSheet'] = item['sleet_length'].length == (Number(all_target.length) + Number(all_dimension.length))
                }
                return item
            })
        },
        // 全选事件
        handleCheckAllChange(val, id) {
            this.setCheckList(val, id)
        },
        // 重置list操作
        setCheckList(val, id, type) {
            let cur_target = []
            let cur_dimension = []
            // let other_target = []
            // let other_dimension = []
            this.list.map(item => {
                if (item.sheet_id == this.sheetActive) {
                    item.field.map(item_c => {
                        let rew_list = []
                        if (item_c.id == id) {
                            item_c.children && item_c.children.forEach(element => {
                                if (val) {
                                    // 全部添加
                                    rew_list.push(element.id)
                                    if (element['field_type'] == 2) {
                                        // item['target'].push(element)
                                        cur_target.push(element)

                                    } else if (element['field_type'] == 0) {
                                        // item['dimension'].push(element)
                                        cur_dimension.push(element)
                                    }
                                } else {
                                    // 全部移除
                                    if (element.disabled == 0) {
                                        rew_list.push(element.id)
                                    } else {
                                        if (element['field_type'] == 2) {
                                            item['target'].forEach((itemTarget, index) => {
                                                if (itemTarget['id'] == element['id']) {
                                                    item['target'].splice(index, 1)
                                                }
                                            })
                                        } else if (element['field_type'] == 0) {
                                            item['dimension'].forEach((itemTarget, index) => {
                                                if (itemTarget['id'] == element['id']) {
                                                    item['dimension'].splice(index, 1)
                                                }
                                            })
                                        }
                                    }
                                }
                            })
                            item_c['isIndeterminate'] = false
                            item_c['list'] = rew_list
                            return item_c
                        }
                    })

                    if (val) {
                        let uniq_target = uniqBy([...item['target'], ...cur_target], 'id')
                        let uniq_dimension = uniqBy([...item['dimension'], ...cur_dimension], 'id')
                        // item['target'] = [...item['target'], ...cur_target]
                        // item['dimension'] = [...item['dimension'], ...cur_dimension]
                        item['target'] = uniq_target
                        item['dimension'] = uniq_dimension
                    }
                    item['checkSheet'] = item['sleet_length'].length == (Number(item['target'].length) + Number(item['dimension'].length))
                }

                return item
            })
        },
        // group 全选事件
        handleGroupCheckedChange(value, id) {
            // let all_value = uniq(value)
            this.list.map(item => {
                if (item.sheet_id == this.sheetActive) {
                    item.field.map(item_c => {
                        if (item_c.id == id) {
                            let checkedCount = value.length;
                            item_c['checkAll'] = checkedCount == item_c.children.length;
                            item_c['isIndeterminate'] = checkedCount > 0 && checkedCount < item_c.children.length;
                            return item_c
                        }
                    })
                    let ispull = item.field.every(item => item['checkAll'] == true)
                    if (ispull) {
                        item['checkSheet'] = true
                    } else {
                        item['checkSheet'] = false
                    }
                }
                return item
            })
        },
        // 当前事件 只与 指标逻辑有关联
        handleCheckedChange(value, ele) {
            this.list.map(item => {
                if (item.sheet_id == this.sheetActive) {
                    if (!value) {
                        // 删除
                        if (ele['field_type'] == 0) {
                            const res_list = item['dimension'].filter(item => item['id'] != ele['id'])
                            item['dimension'] = res_list
                        } else if (ele['field_type'] == '2') {
                            const res_list = item['target'].filter(item => item['id'] != ele['id'])
                            item['target'] = res_list
                        }
                    } else {
                        // 添加
                        if (ele['field_type'] == 0) {
                            item['dimension'].push(ele)
                        } else if (ele['field_type'] == '2') {
                            item['target'].push(ele)
                        }
                    }
                }
                return item
            })
        },
        // 保存
        handleSubmit() {
            this.$refs['formInline'].validate((valid) => {
                if (valid) {
                    this.submitloading = true
                    let sheet_sort = this.list.filter(item => item['checked'] == 1).map(item => {
                        return { id: item['sheet_id'], name: item['template_name'] }
                    })
                    let chone_list = cloneDeep(this.list)
                    let submit_target_list = []
                    let submit_dimension_list = []
                    let concat_item = []
                    concat_item = chone_list.filter(item => item['checked'] == 1).map(item => {
                        submit_target_list = item['target'].map(item_t => {
                            return {
                                id: item_t['id'],
                                edit_name: item_t['edit_name']
                            }
                        })
                        submit_dimension_list = item['dimension'].map(item_t => {
                            return {
                                id: item_t['id'],
                                edit_name: item_t['edit_name']
                            }
                        })
                        return {
                            id: item.sheet_id,
                            list: [...submit_dimension_list, ...submit_target_list]
                        }
                    })
                    let params = {
                        ...this.formInline,
                        sheet_sort: JSON.stringify(sheet_sort),
                        sheet_ids_field_ids: JSON.stringify(concat_item)
                    }
                    if (this.type == 'edit') {
                        postTemplateUpdate({ ...params, template_id: this.pull['template_id'] }).then(res => {
                            this.$message({
                                message: 'Success',
                                type: 'success'
                            });
                            setTimeout(() => {
                                this.submitloading = false
                                this.handleBack()
                            }, 2000);
                        }, err => {
                            this.submitloading = false
                            this.$message.error(err.info);
                        })
                    } else {
                        params.type = this.type == 'copy'?'2':'1';
                        postTemplateCreate(params).then(res => {
                            this.$message({
                                message: 'Success',
                                type: 'success'
                            });
                            setTimeout(() => {
                                this.submitloading = false
                                this.handleBack()
                            }, 2000);
                        }, err => {
                            this.submitloading = false
                            this.$message.error(err.info);
                        })
                    }
                    // let chone_list = cloneDeep(this.list)
                    // let sheet_ids_field_ids = []
                    // let concat_item = []
                    // chone_list.forEach(item => {
                    //     item['field'].forEach(item_c => {
                    //         concat_item = item_c['list'].map(element => `${item_c['sheet_id']}_${element}`)
                    //         sheet_ids_field_ids.push(concat_item)
                    //     })

                    // })
                    // console.log('sheet_ids_field_ids', sheet_ids_field_ids)
                } else {
                    this.submitloading = false
                    return false;
                }
            });
        },
        // 以下为dialog弹框逻辑
        handleDialog(type) {
            this.dialogtype = type
            if (type == 'add') {
                if (this.dialogCheckList.length == 0) {
                    this.$message({
                        type: 'info',
                        message: 'Media not selected, can be added after selecting media.'
                    });
                    return
                }
                this.dialogList.add.list = this.dialogCheckList
                let res_dialog_list = this.list.filter(item => item['checked'] == 1).map(item => item['sheet_id'])
                this.dialogList.add.dialogCheckAll = res_dialog_list.length === this.list.length
                this.dialogList.add.dialogIsIndeterminate = res_dialog_list.length > 0 && res_dialog_list.length < this.list.length
                this.dialogList.add.dialogChecked = res_dialog_list
            } else {
                this.dialogList.pull.list = this.list.filter(item => item['checked'] == 1).map(item => { return { sheet_id: item['sheet_id'], template_name: item['template_name'] } }).filter(item => item.sheet_id != this.sheetActive && item.sheet_id != 1)
                this.dialogList.pull.dialogChecked = []
                this.dialogList.pull.dialogCheckAll = false
                this.dialogList.pull.dialogIsIndeterminate = false
            }
            this.dialogVisible = true
        },
        handleClose() {
            this.dialogVisible = false
        },
        isPrime(element) {
            if (element % 2 === 0 || element < 2) {
                return false;
            }
            for (let factor = 3; factor <= Math.sqrt(element); factor += 2) {
                if (element % factor === 0) {
                    return false;
                }
            }
            return true;
        },
        handleOk(type) {
            if (type == 'add') {
                let add_list = this.dialogList.add.dialogChecked
                this.list.map(item => {
                    if (add_list.includes(item.sheet_id)) {
                        if(item['checked'] == 0) {
                            let t_name = this.dialogList.add.list.filter(itemc=>itemc['sheet_id'] == item.sheet_id)[0]['template_name']
                            item['checked'] = 1
                            item['template_name'] = t_name



                            // item['indexs'] = index
                            // item['tagActive'] = 1
                            item['checkSheet'] = false
                            item['sleet_length'] = []   //全部checkbox
                            let init_target = []
                            let init_dimension = []
                            // if (this.type == 'info') {
                            //     item['disabled'] = 0
                            // } else {
                            //     item['disabled'] = 1
                            // }
                            item['field'].map(item_c => {
                                    item_c['checkAll'] = false
                                    item_c['isIndeterminate'] = false
                                    item_c['list'] = []
                                    // if (this.type == 'info') {
                                    //     item_c['disabled'] = 0
                                    // }
                                    item_c.children && item_c.children.forEach(element => {
                                        item['sleet_length'].push(element.id)
                                        // if (this.type == 'create') {
                                        //     element['edit_name'] = element['display_name']
                                        // }
                                        element['edit_name'] = element['display_name']

                                        if (element.checked == 1) {
                                            item_c['list'].push(element.id)
                                        }

                                        if (element['field_type'] == 2) {
                                            if (element.checked == 1) {
                                                init_target.push(element)
                                            }
                                        } else if (element['field_type'] == 0) {
                                            if (element.checked == 1) {
                                                init_dimension.push(element)
                                            }
                                        }
                                    })

                                    let checkedCount = item_c['list'].length
                                    item_c['checkAll'] = checkedCount == item_c.children.length;
                                    item_c['isIndeterminate'] = checkedCount > 0 && checkedCount < item_c.children.length;
                                    return item_c
                                })
                                item['target'] = init_target
                                item['dimension'] = init_dimension
                                item['checkSheet'] = item['sleet_length'].length == (Number(init_target.length) + Number(init_dimension.length))
                        }
                    } else {
                        item['checked'] = 0
                    }
                    return item
                })

                this.sheetActive = add_list.length != 0 ? add_list[0] : ''
                this.dialogVisible = false
                return
            }

            if (this.dialogList.pull.dialogChecked.length == 0) {
                this.$message({
                    type: 'info',
                    message: 'Not selected, not synchronized to other sheets'
                });
                return
            }

            let cache_list = this.list.filter(item => item['sheet_id'] == this.sheetActive)
            // this.list[this.sheetIndex]['target']
            let cache_target_list = cloneDeep(cache_list[0]['target'])
            let cache_dimension_list = cloneDeep(cache_list[0]['dimension'])

            let cache_name_list = [...cache_target_list, ...cache_dimension_list]
            let id_list = cache_name_list.filter(item => item['disabled'] == 1).map(item => item.id)
            let name_list = cache_name_list.filter(item => item['disabled'] == 1).map(item => ({ id: item.id, name: item.name }))  //选中name
            let no_select_list = []  //当前未选中name
            cache_list[0]['field'].forEach(item_c => {
                item_c.children && item_c.children.forEach(element => {
                    if (!id_list.includes(element['id']) && element['disabled'] == 1) {
                        no_select_list.push({ id: element['id'], name: element['name'] })
                    }
                })
            })

            const newokkk = this.list.map(item => {
                if (this.dialogList.pull.dialogChecked.includes(item['sheet_id'])) {
                    let cache_target_select = [] // 选中指标维度排序
                    let cache_dimension_select = [] //选中维度排序
                    item.field.map(item_c => {
                        item_c.children && item_c.children.map(element => {
                            no_select_list.forEach(nitem => {
                                if (element['name'] == nitem['name'] && element['disabled'] == 1) {
                                    let del_number = item_c['list'].findIndex(ele => ele == element['id'])
                                    if (del_number != -1) {
                                        item_c['list'].splice(del_number, 1)
                                    }
                                }
                            })
                            name_list.forEach((addItem) => {
                                if (element['disabled'] == 1 && element['name'] == addItem['name']) {
                                    item_c['list'].push(element['id'])
                                }
                            })
                            item_c['list'] = uniq(item_c['list'])
                            // 维度
                            if (element['field_type'] == 0 && item_c['list'].includes(element['id'])) {
                                cache_dimension_select.push(element)
                            }
                            // 指标
                            if (element['field_type'] == 2 && item_c['list'].includes(element['id'])) {
                                cache_target_select.push(element)
                            }
                        })

                        let checkedCount = item_c['list'].length
                        item_c['checkAll'] = checkedCount == item_c.children.length;
                        item_c['isIndeterminate'] = checkedCount > 0 && checkedCount < item_c.children.length;

                        return item_c
                    })


                    // 同步指标数据 指标数据需要同步排序
                    let cur_target = []
                    cache_target_list.forEach(itemt => {
                        cache_target_select.forEach(itemc => {
                            if (itemt['name'] == itemc['name']) {
                                itemc['edit_name'] = itemt['edit_name']
                                cur_target.push(itemc)
                            }
                        })
                    })
                    let other_target = uniqBy([...cur_target, ...cache_target_select], 'id')
                    item['target'] = other_target

                    // 同步维度数据 维度数据不需排序
                    item['dimension'] = cache_dimension_select.map(itemeled => {
                        cache_dimension_list.forEach(itemd => {
                            if (itemd['name'] == itemeled['name']) {
                                itemeled['edit_name'] = itemd['edit_name']
                            }
                        })
                        return itemeled
                    }).filter(itemf => itemf['field_type'] == 0)

                    let ispull = item.field.every(item => item['checkAll'] == true)
                    if (ispull) {
                        item['checkSheet'] = true
                    } else {
                        item['checkSheet'] = false
                    }
                    return item
                }
            })
            this.$message({
                type: 'success',
                message: 'Success'
            });
            this.dialogVisible = false
        },
        // 全选
        handleDialogCheckAllChange(val, type) {
            if (type == 'add') {
                let checksetarr = this.dialogCheckList.map(item => item['sheet_id'])
                this.dialogList.add.dialogIsIndeterminate = false
                this.dialogList.add.dialogChecked = val ? checksetarr : []
            } else {
                let checksetarr = this.dialogList.pull.list.map(item => item['sheet_id']).filter(item=>item != 1)
                this.dialogList.pull.dialogIsIndeterminate = false
                this.dialogList.pull.dialogChecked = val ? checksetarr : []
            }
        },
        handleCheckedDialogChange(value, type) {
            if (type == 'add') {
                let checkedCount = value.length;
                this.dialogList.add.dialogCheckAll = checkedCount === this.dialogList.add.list.length;
                this.dialogList.add.dialogIsIndeterminate = checkedCount > 0 && checkedCount < this.dialogList.add.list.length;
            } else {
                let checkedCount = value.length;
                this.dialogList.pull.dialogCheckAll = checkedCount === this.dialogList.pull.list.length;
                this.dialogList.pull.dialogIsIndeterminate = checkedCount > 0 && checkedCount < this.dialogList.pull.list.length;
            }
        },
        // 以下为弹出框逻辑 pop

        /**
         * 
         * sheet  pop
         */
        handleEditPop(id) {
            let cache_list = this.list.filter(item => item['sheet_id'] == id)
            this.sheetActive = id
            this.dialogVisibleEdit = true
            this.dialogEdittype = 'sheet'
            this.dialogEditList['sheet']['text'] = cache_list[0]['template_name']
        },
        handleSheetDel(id) {
            // let del_number = this.list.findIndex(ele => ele['sheet_id'] == id)
            // this.list.splice(del_number, 1)
            // this.list.filter(item => item['sheet_id'] == id).map(item=>{
            //     item['checked'] = 0
            // })
            let sheetList = this.list.map(item => {
                if (item['sheet_id'] == id) {
                    item['checked'] = 0
                }
                return item
            }).filter(item=>item['checked'] == 1)
            if(sheetList.length > 0 && this.sheetActive == id) {
                this.sheetActive = sheetList[sheetList.length - 1]['sheet_id']
            }
            
        },
        /**
         * 
         * sheet  dialog
         */
        handleEditClose(type) {
            this.dialogVisibleEdit = false
        },
        handleEditOk(type) {
            let cache_list = this.list.filter(item => item['sheet_id'] == this.sheetActive)
            let all_chidlen_list = []
            if(cache_list.length == 0) {
                return
            }
            cache_list[0]['field'].forEach(item => {
                all_chidlen_list.push(...item.children)
            })
            if (type == 'sheet') {
                // let equal_sheet = this.list.some(item => item.template_name == this.dialogEditList[type]['text'])
                // if(equal_sheet) {
                //     if(cache_list[0]['template_name'] != this.dialogEditList[type]['text']){
                //         this.$message.error('sheet名称重复');
                //         return
                //     }
                // }
                cache_list[0]['template_name'] = this.dialogEditList[type]['text']
            } else {
                let equal_name = all_chidlen_list.some(item => item['edit_name'] == this.dialogEditList[type]['text'])
                if(equal_name) {
                    // this.$message.error('表头名称重复');
                    // return
                    if (cache_list[0]['tagActive'] == '1') {
                        
                        if(cache_list[0]['target'][this.tagIndex]['edit_name'] != this.dialogEditList[type]['text']) {
                            this.$message.error('Duplicate header names');
                            return
                        }
                    } else {
                        if(cache_list[0]['dimension'][this.tagIndex]['edit_name'] != this.dialogEditList[type]['text']) {
                            this.$message.error('Duplicate header names');
                            return
                        }
                    }
                }
                if (cache_list[0]['tagActive'] == '1') {
                    cache_list[0]['target'][this.tagIndex]['edit_name'] = this.dialogEditList[type]['text']
                } else {
                    cache_list[0]['dimension'][this.tagIndex]['edit_name'] = this.dialogEditList[type]['text']
                }

            }
            this.dialogVisibleEdit = false

        },
        /**
         * 
         * 指标删除  pop
         */
        handleCheckDel(index, id) {
            let cache_list = this.list.filter(item => item['sheet_id'] == this.sheetActive)
            cache_list[0]['target'].splice(index, 1)
            this.list.map(item => {
                if (item.sheet_id == this.sheetActive) {
                    item.field.map((item_c) => {
                        let del_number = item_c['list'].findIndex(ele => ele == id)
                        if (del_number != -1) {
                            item_c['list'].splice(del_number, 1)
                            // item_c['checkAll'] = false;
                            // item_c['isIndeterminate'] = true
                            let checkedCount = item_c['list'].length
                            item_c['checkAll'] = checkedCount == item_c.children.length;
                            item_c['isIndeterminate'] = checkedCount > 0 && checkedCount < item_c.children.length;
                            return item_c
                        }
                    })
                    let ispull = item.field.every(item => item['checkAll'] == true)
                    if (ispull) {
                        item['checkSheet'] = true
                    } else {
                        item['checkSheet'] = false
                    }
                }
                return item
            })
        },
        handleCheckPop(index, type) {
            let cache_list = this.list.filter(item => item['sheet_id'] == this.sheetActive)
            this.tagIndex = index
            this.dialogVisibleEdit = true
            this.dialogEdittype = 'target'
            this.dialogEditList['target']['text'] = cache_list[0][type][index]['edit_name']
        }
    }
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.list-page ::v-deep.el-table .gray-row {
    background-color: #f4f4f4;
}

.ellipsis {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.create_vivo_list tbody .cell div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.demo-form-inline {
    padding: 20px 20px 0;
    background: #f8f8f9;
    margin-bottom: 20px;
}
</style>
<style lang="scss" scoped>
.temp_create {
    display: flex;
    flex-wrap: nowrap;
    border: 1px solid #ccc;
    width: 100%;
    min-width: 880px;
    min-height: 200px;
}

.sheet {
    width: 220px;
    background-color: #fff;
    border-right: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-y: auto;
    flex: 0 0 220px;

    .title {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ccc;
        padding: 6px 8px;
    }

    .create_body {
        overflow-y: auto;
        max-height: 600px;
        .create_list {
            .list_item {

                cursor: pointer;

                .list_item_checked {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: nowrap;
                    border-bottom: 1px solid #ccc;
                    padding-left: 8px;
                    padding-right: 8px;

                    .list_item_title {
                        flex: auto;
                        padding: 8px 0;
                        display: flex;
                        align-items: center;
                    }

                }

                .action {
                    flex: 0 0 34px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    i {
                        font-size: 14px;

                        &.el-icon-edit-outline {
                            color: #409EFF;
                        }

                        &.el-icon-delete {
                            color: red;
                        }
                    }
                }

                &:hover {
                    background-color: rgba(242, 242, 242, 1);
                }

                &:first-child {
                    border-bottom: 1px solid #ccc !important;
                }

                &:last-child {
                    .list_item_checked {
                        border: none;
                    }
                }

                &.active {
                    background-color: #66b1ff;
                    color: #fff;

                    i {
                        &.el-icon-edit-outline {
                            color: #fff;
                        }
                    }

                }
            }
        }

        .create_list_nodrag {
            .list_item {

                cursor: pointer;

                .list_item_title {
                    flex: auto;
                    padding: 8px 0;
                    display: flex;
                    align-items: center;
                    padding-left: 8px;
                    padding-right: 8px;
                }

                .action {
                    flex: 0 0 34px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    i {
                        font-size: 14px;

                        &.el-icon-edit-outline {
                            color: #409EFF;
                        }

                        &.el-icon-delete {
                            color: red;
                        }
                    }
                }

                &:hover {
                    background-color: rgba(242, 242, 242, 1);
                }

                &:first-child {
                    border-bottom: 1px solid #ccc !important;
                }

                &:last-child {
                    .list_item_checked {
                        border: none;
                    }
                }

                &.active {
                    background-color: #66b1ff;
                    color: #fff;

                    i {
                        &.el-icon-edit-outline {
                            color: #fff;
                        }
                    }

                }
            }
        }
    }

}

.checkList {
    background-color: #fff;
    flex: auto;

    .title {
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #ccc;
        padding: 6px 8px;
    }

    .check_con {
        padding: 6px 8px;

        .check_header {
            background-color: rgba(242, 242, 242, 1);
            height: 36px;
            line-height: 36px;
            padding: 0 8px;
            margin-bottom: 10px;
        }

        .check_body {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            width: 100%;

            .left {
                // min-width: 750px;
                flex: 1 1 auto;
                max-height: 522px;
                overflow-y: auto;

                .check_left_list {
                    .wk-el-checkbox-group {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: flex-start;
                        width: 100%;

                        .wk-el-checkbox {
                            // width: 25%;
                            // flex: 0 0 25%;
                            min-width: 25%;
                            padding-right: 12px;
                            display: flex;
                            align-items: center;

                            .questions {
                                width: 12px;
                                height: 12px;
                                line-height: 12px;
                                text-align: center;
                                border-radius: 10px;
                                background-color: #333;
                                color: #fff;
                                font-size: 12px;
                                display: inline-block;
                                margin-left: 1px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }

            .right {
                // width: 220px;
                flex: 0 0 220px;
                border: 1px solid #ccc;

                .button-group {
                    width: 100%;
                    display: flex;
                    flex-wrap: nowrap;
                    border-bottom: 1px solid #ccc;

                    .button-group-item {
                        width: 50%;
                        text-align: center;
                        padding: 6px 0;
                        cursor: pointer;

                        &.active {
                            background-color: #66b1ff;
                            color: #fff;
                        }
                    }
                }

                .right-body {
                    // padding: 0px 8px;
                    max-height: 522px;
                    overflow-y: auto;

                    .check_right_list {
                        .check_right_list_item {
                            border-bottom: 1px solid #ccc;
                            padding-left: 8px;
                            padding-right: 8px;
                            cursor: pointer;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            flex-wrap: nowrap;

                            .list_item_title {
                                flex: auto;
                                padding: 8px 0;
                                display: flex;
                                align-items: center;
                            }

                            .action {
                                flex: 0 0 34px;
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;

                                i {
                                    font-size: 14px;

                                    &.el-icon-edit-outline {
                                        color: #409EFF;
                                    }

                                    &.el-icon-delete {
                                        color: red;
                                        margin-left: 5px;
                                    }
                                }
                            }

                            &:hover {
                                background-color: rgba(242, 242, 242, 1);
                            }

                            &:first-child {
                                border-bottom: 1px solid #ccc !important;
                            }

                            &:last-child {
                                border: none;
                            }

                            &.active {
                                background-color: #66b1ff;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 1280px) {
    .checkList {
        .check_con {
            .check_body {
                .left {
                    // min-width: 550px;
                    .check_left_list {
                        .wk-el-checkbox-group {
                            .wk-el-checkbox {
                                min-width: 33%;
                            }
                        }
                    }
                }
                .right{
                    flex: 0 0 200px;
                }
            }
        }


    }
}

@media (max-width: 1080px) {
    .checkList {
        .check_con {
            .check_body {
                .left {
                    // min-width: 550px;
                    .check_left_list {
                        .wk-el-checkbox-group {
                            .wk-el-checkbox {
                                min-width: 50%;
                            }
                        }
                    }
                }
                .right{
                    flex: 0 0 180px;
                }
            }
        }


    }
}
</style>
